// NOTICE: KAPTION-INTEGRATION
// Creates a Web Worker with Fuse.js bundled inline via blob URL.
// This avoids Vite's module resolution issues with workers in dev mode.
// Direct path to fuse.min.js UMD bundle — bypasses package "exports" restriction
// which blocks `fuse.js/dist/fuse.min.js`. We need the raw source to embed in a blob worker.
// eslint-disable-next-line
import fuseSource from '../../../../../../../node_modules/fuse.js/dist/fuse.min.js?raw';

const FUSE_OPTIONS = JSON.stringify({
  keys: [
    { name: 'short_code', weight: 0.6 },
    { name: 'content', weight: 0.4 },
  ],
  threshold: 0.4,
  ignoreLocation: true,
  includeScore: true,
});

const workerCode = `
(function() {
${fuseSource}
})();

var OPTS = ${FUSE_OPTIONS};
var dataset = [];
var fuseIndex = null;

self.onmessage = function(e) {
  var type = e.data.type;
  var payload = e.data.payload;
  if (type === 'setData') {
    dataset = payload;
    fuseIndex = new Fuse(dataset, OPTS);
    self.postMessage({ type: 'ready' });
    return;
  }

  if (type === 'search') {
    var query = payload.query;
    var filter = payload.filter;
    var list = dataset;

    if (filter === 'favorites') {
      list = list.filter(function(r) { return r.is_favorite; });
    }

    if (query.trim()) {
      var fuse = filter === 'favorites'
        ? new Fuse(list, OPTS)
        : fuseIndex;
      var results = fuse.search(query.trim()).map(function(r) { return r.item; });
      self.postMessage({ type: 'results', payload: results });
      return;
    }

    if (filter === 'all') {
      var sorted = list.slice().sort(function(a, b) {
        if (a.is_favorite && !b.is_favorite) return -1;
        if (!a.is_favorite && b.is_favorite) return 1;
        return 0;
      });
      self.postMessage({ type: 'results', payload: sorted });
      return;
    }

    self.postMessage({ type: 'results', payload: list });
  }
};
`;

export function createFuseWorker() {
  const blob = new Blob([workerCode], { type: 'application/javascript' });
  const url = URL.createObjectURL(blob);
  const worker = new Worker(url);
  // Clean up blob URL after worker loads
  worker.addEventListener('message', () => URL.revokeObjectURL(url), {
    once: true,
  });
  return worker;
}
